import { render, staticRenderFns } from "./Wp_news.vue?vue&type=template&id=58e067cf&scoped=true&"
import script from "./Wp_news.vue?vue&type=script&lang=js&"
export * from "./Wp_news.vue?vue&type=script&lang=js&"
import style0 from "./Wp_news.vue?vue&type=style&index=0&id=58e067cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e067cf",
  null
  
)

export default component.exports